import { render, staticRenderFns } from "./Socios.vue?vue&type=template&id=39856ba1"
import script from "./Socios.vue?vue&type=script&lang=js"
export * from "./Socios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports